import { Content, HistoryContent } from "@/types/content";
import { Box, SimpleGrid } from "@chakra-ui/react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import HistoryModalItem from "./historyModalItem";

import { RiRecordCircleLine } from "@remixicon/react";
import { format } from "date-fns";

type Props = {
  images: Content[];
  isBatch: boolean;
  handleCheckBox: (e: React.ChangeEvent<HTMLInputElement>, id: string)=>void;
  onClose: () => void;
};


const TimeLine = (props: Props) => {
  const { images, isBatch, handleCheckBox, onClose } = props;

  // 分组函数
  const groupByDate = (
    items: Content[]
  ): Record<string, Content[]> => {
    return items.reduce((acc: Record<string, Content[]>, item) => {
      const dateKey = format(item.create_at, "yyyy-MM-dd");
      acc[dateKey] = [...(acc[dateKey] || []), item];
      return acc;
    }, {});
  };

  // 排序函数
  const sortItems = (items: Content[]): Content[] => {
    return items.sort(
      (a, b) => b.create_at - a.create_at
    );
  };

  // 应用分组和排序
  const groupedAndSortedItems = groupByDate(sortItems(images));

  var i=0;
  return (
    <Box>
      <VerticalTimeline layout="1-column-left" lineColor="#8E94A9">
        {Object.entries(groupedAndSortedItems).map(([date, items]) => (
          <VerticalTimelineElement
            key={date}
            contentStyle={{ background: "none", boxShadow:"none", padding: 0, color: "#fff"}}
            contentArrowStyle={{ borderRight: "7px solid rgb(150,190,100)", border: "none", }}
            // date={date}
            iconStyle={{ background: "none", border: "none", boxShadow:"none", color: "#fff" }}
            icon={<RiRecordCircleLine />}
          >
            <Box >
              <Box color={"#fff"} fontSize="14px" mb="7px" pt="10px">{date}</Box>
              <SimpleGrid columns={5} spacing={"10px"}>
                {items.map((item, index) => {
                  i=i+1;
                  return (
                    <HistoryModalItem
                      key={item.id}
                      content={item}
                      index={i-1}
                      isBatch={isBatch}
                      handleCheckBox={handleCheckBox}
                      onClose={onClose}
                    />
                  )
                  
                })}
              </SimpleGrid>
            </Box>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </Box>
  );
};

export default TimeLine;
